import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { Brand } from '../../../business-entities/brand.model';
import { FuelType } from '../../../business-entities/fuel-view-model';
import { VehicleListViewModel } from '../../../business-entities/vehicle-list-view-model';
import { CheckListBusinessService } from '../../../business-services/check-list.service';
import { EditAppointmentService } from '../../../business-services/edit-appointment.service';
import { RentalCarService } from '../../../business-services/rental-car.service';
import { VehicleBusinessService } from '../../../business-services/vehicle-service';
import { Constant } from './../../../../../../Autofacets-Core/src/app/utils/constant';
import * as Enums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import { Utility } from './../../../../../../Autofacets-Core/src/app/utils/utility';
import { VehicleType } from './../../../business-entities/vehicleTypes-model';

const CustomerTabs: { id: number; label: string; route: string }[] = [
  { id: 1, label: 'lblWorkOrderHistory', route: 'workOrderHistory' },
];
const VehicleTabs: { id: number; label: string; route: string }[] = [
  { id: 1, label: 'lblVehicleDetails', route: 'vehicles' },
  { id: 2, label: 'lblCustomerDetails', route: 'details' },
  { id: 3, label: 'lblWorkOrderHistory', route: 'workOrderHistory' },
  { id: 4, label: 'lblVehicleOwnershipHistory', route: 'vehicleOwnershipHistory' },
];

@Component({
  selector: 'app-edit-vehicle',
  templateUrl: './edit-vehicle.component.html',
  styleUrls: ['./edit-vehicle.component.css'],
})
export class EditVehicleComponent implements OnInit {
  vehicleDetail: VehicleListViewModel;
  vehicleId: number;
  editVehicleForm: FormGroup;
  selectedDate: string;
  fuelType: FuelType[];
  fuels: FuelType[] = [];
  brandList: Brand[] = [];
  brand: Brand[];
  vehicleTypes: VehicleType[] = [];
  color: string;
  IsSearch: boolean = false;
  licensePlate: string;
  make: string;
  model: string;
  registrationDate: string;
  licensePlateClass: string;
  historyTab: { id: number; label: string; route: string }[] = CustomerTabs;
  tabs: { id: number; label: string; route: string }[] = VehicleTabs;
  selectedtab: number = 1;

  @Input() fromHistory: any;
  @Input() fromWorkOrder: any;

  constructor(
    private formBuilder: FormBuilder,
    private vehicleBusinessService: VehicleBusinessService,
    private EditRentalCar: RentalCarService,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private editAppointmentService: EditAppointmentService,
    private checkListService: CheckListBusinessService,
    private globalSetting: GlobalSetting,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.vehicleId = this.vehicleBusinessService.vehicleId;
    this.licensePlate = this.vehicleBusinessService.licensePlate;
    this.make = this.vehicleBusinessService.make;
    this.model = this.vehicleBusinessService.model;
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    this.editVehicleForm = this.formBuilder.group({
      id: ['', []],
      licensePlate: [
        '',
        [Validators.required, Validators.pattern(/^[a-zA-Z0-9_ ]*$/)],
      ],
      engineSerialNo: ['', [Validators.required]],
      companyMakeCode: [{ value: '', disabled: true }],
      companyModel: ['', [Validators.required]],
      companyMakeName: [{ value: '', disabled: true }],
      mchCode: [''],
      registrationDate: [{ value: '', disabled: true }],
      color: [''],
      year: [
        '',
        [
          Validators.required,
          Validators.max(new Date().getFullYear()),
          Validators.min(1850),
          Validators.pattern(/^\d{4}$/),
        ],
      ],
      chassisNo: ['', [Validators.required]],
      fuelType: [''],
      vehicleTypeId: ['', [Validators.required]],
    });
    if(this.fromWorkOrder){
      this.tabs = VehicleTabs.filter(x=>x.id == 1);
    }
    this.selectedtab = this.vehicleBusinessService.selectedTab ?? this.selectedtab;
  }

  async initialize(): Promise<void> {
    this.spinner.show();
    const fuelDrodownPromise = this.GetAllFuelTypes();
    const brandDrodownPromise = this.GetAllBrand();
    const vehicleTypeDrodownPromise = this.GetAllVehicleTypes();
    Promise.all([
      fuelDrodownPromise,
      brandDrodownPromise,
      vehicleTypeDrodownPromise,
    ]).then((_) => {
      this.spinner.hide();
      this.getVehicle(this.vehicleId);
    });
  }

  async GetAllFuelTypes(): Promise<void> {
    await this.EditRentalCar.GetFuelTypes().then((data) => {
      this.fuelType = data.responseObject.result;
      this.fuels = this.fuelType.slice();
    });
  }

  async GetAllBrand(): Promise<void> {
    await this.EditRentalCar.GetAllBrand().then((data) => {
      this.brand = data.responseObject;
      this.brandList = this.brand.slice();
    });
  }

  async GetAllVehicleTypes(): Promise<void> {
    await this.checkListService.getVehicleTypes().then((data) => {
        this.vehicleTypes = data.responseObject.filter(x => x.isDisplay);
    });
  }

  get cpf(): any {
    return this.editVehicleForm.controls;
  }

  public selectedCompany(brand: string): void {
    const makeCode = this.brandList.filter((x) => {
      if (x.brandName === brand) {
        return x.brandCode;
      }
    });
    if (makeCode) {
      this.editVehicleForm.patchValue({
        companyMakeCode: makeCode[0].brandCode,
      });
    }
  }

  changeDate(event: any): void {
    this.selectedDate = Utility.GetFormattedDate(event);
  }

  changeCalender(event: Date): void {
    this.selectedDate = Utility.GetFormattedDate(event);
  }

  async getVehicle(vehicleId: number): Promise<void> {
    this.spinner.show();
    await this.vehicleBusinessService
      .getVehicleById(vehicleId)
      .then((response) => {
        if (response.responseCode === Constant.SuccessResponseCode) {
          this.vehicleDetail = response.responseObject;
          if (this.vehicleDetail) {
            this.registrationDate = this.vehicleDetail.registrationDate;
          }
          this.color = this.vehicleDetail.color;
          this.editVehicleForm.patchValue({
            ...response.responseObject,
            fuelType: +this.fuels.find(
              (x) => x.fuelType === this.vehicleDetail.fuelType
            ).id,
          });
        } else if (
          response.responseObject &&
          response.responseObject.errorCount > 0
        ) {
          if (
            response.responseObject.result &&
            response.responseObject.result.errorCode ===
              Enums.ErrorCodes.ServicecategoriesNotFound
          ) {
            this.toaster.error(Enums.ToastrMessages.VehicleNotFound);
          }
        }
        this.spinner.hide();
      });
  }

  onSubmit(): void {
    const licensePlate = this.cpf.licensePlate.value.toString().toUpperCase();
    const viewModel: VehicleListViewModel = {
      ...this.editVehicleForm.value,
      vehicleId: this.vehicleDetail.vehicleId,
      companyMakeCode: this.cpf.companyMakeCode.value,
      color: this.color,
      registrationDate: this.registrationDate,
      licensePlate,
    };
    this.spinner.show();
    this.vehicleBusinessService.editVehicle(viewModel).then((response) => {
      if (response.responseObject && response.responseObject.errorCount > 0) {
        if (
          response.responseObject.result &&
          response.responseObject.result.errorCode ===
            Enums.ErrorCodes.DuplicateEntry
        ) {
          this.toaster.error(response.responseObject.result.errorMessage);
          this.spinner.hide();
        }
      } else if (response.responseCode === Constant.SuccessResponseCode) {
        this.toaster.success(Enums.ToastrMessages.EditVehicle);
        this.spinner.hide();
        this.activeModal.close({ success: true });
      }
      this.spinner.hide();
    });
  }
  OnClose() {
    this.activeModal.close({ success: false });
    this.editAppointmentService.isFromVehicleHistoricalTab = false;
  }

  tabSelected(id) {
    this.selectedtab = id;
    if(id == 3){
      this.editAppointmentService.isFromVehicleHistoricalTab = true;
    }
  }
}
